// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vkn: CountryValidator<"TR"> = createValidator(
  "tr.vkn",
  165,
);

export default vkn;
export const compact = vkn.compact;
export const format = vkn.format;
export const validate = vkn.validate;
export const generate = (): string =>
  vkn.generate?.() ??
  (() => {
    throw new Error(
      "Validator tr.vkn cannot generate values",
    );
  })();
